import { render, staticRenderFns } from "./YwDutyRecordList.vue?vue&type=template&id=e4ffb9e2&scoped=true&"
import script from "./YwDutyRecordList.vue?vue&type=script&lang=js&"
export * from "./YwDutyRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ffb9e2",
  null
  
)

export default component.exports